// extracted by mini-css-extract-plugin
export default {"button":"style_button__AM5Pn","icon":"style_icon__oOosk","text":"style_text__kfaaj"};